import images from '@assets/images/index'
import { Flex } from 'antd'
import { CSSProperties } from 'react'
import { Draggable, DraggingStyle, NotDraggingStyle } from 'react-beautiful-dnd'
import { MovePlayersPlayerWithTeamInfo } from 'src/types/type'

import { Popover } from '@suntex.fim/ui'

import PopOverContent from './PopOverContent'

type PlayerDraggableListItemProps = {
  student: MovePlayersPlayerWithTeamInfo
  getItemStyle: (
    isDragging: boolean,
    draggableStyle: DraggingStyle | NotDraggingStyle | undefined
  ) => CSSProperties
}

function PlayerDraggableListItem({
  student,
  getItemStyle
}: Readonly<PlayerDraggableListItemProps>) {
  return (
    <Draggable
      key={student.id}
      draggableId={String(student.id)}
      index={student.teamId ?? 0}
    >
      {(provided, snapshot) => (
        <Popover
          overlayClassName="suntex-popover-overlay--player-tiles"
          content={PopOverContent(student)}
        >
          <li
            className="player-tiles"
            key={student.id}
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={getItemStyle(
              snapshot.isDragging,
              provided.draggableProps.style
            )}
          >
            <h6>{student.displayName ?? '<No Name>'}</h6>
            <Flex justify="space-between">
              <Flex align="center" gap="4px">
                <span>
                  <images.Hashtag />
                </span>
                <p className="text-chalkboard-txt">
                  {student.userId ?? 'None'}
                  {student.idNumber ? `/ ${student.idNumber}` : ''}
                </p>
              </Flex>
            </Flex>
          </li>
        </Popover>
      )}
    </Draggable>
  )
}
export default PlayerDraggableListItem
